import { render, staticRenderFns } from "./DialogInfoResource.vue?vue&type=template&id=48f79a4b&"
import script from "./DialogInfoResource.vue?vue&type=script&lang=js&"
export * from "./DialogInfoResource.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports